import React from 'react';
import styles from './Switcher.module.scss'
import {SwitcherPropsInterface} from "./Switcher.props.interface";
import Message from "../Message";

const Switcher: React.FC<SwitcherPropsInterface> = (
    {
        size = 'medium',
        value = false,
        disabled = false,
        error = undefined,
        children = undefined,
        reverse = false,
        className = undefined,
        onChange,
        ...rest
    }) => {

    return (

        <label
            id={rest.id}
            className={[
                styles.container,
                size ? styles[size] : null,
                value ? styles.checked : null,
                disabled ? styles.disabled : null,
                error ? styles.error : null,
                className,
            ].filter(x => x ?? x).join(' ')} {...rest}>
            <div className={styles.content}>
                <input
                    type={'checkbox'}
                    tabIndex={rest.tabIndex}
                    id={rest.id}
                    checked={value}
                    onChange={onChange}
                />

                {children ? <div className={[
                    reverse ? styles.left : styles.right
                ].filter(x => x ?? x).join(' ')}>
                    {children}
                </div> : null}

                <div className={styles.checkmark}/>
            </div>

            {error ? <Message
                type={'danger'}
                children={error}
            /> : null}

        </label>
    );
};

export default Switcher;
